import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import {
  LandingConfigResponse,
  LandingFormValue,
  PresignedPdfResponse,
} from '../../domain/landing-config.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LandingService {
  constructor(private api: ApiService) {}

  // /config devuelve un array de configs; la landing usa la primera activa
  getConfig(): Observable<LandingConfigResponse> {
    return this.api
      .get<LandingConfigResponse[]>('/config')
      .pipe(map((list) => list.find((c) => c.status === 'active') ?? null));
  }

  // Valor del formulario para un customKey (el formValueId de la landing), en su última versión
  getFormValue(formId: string, customKey: string): Observable<LandingFormValue> {
    return this.api.get<LandingFormValue>(
      `/forms/${formId}/versions/latest/values/${encodeURIComponent(customKey)}`
    );
  }

  // URL firmada (temporal) del PDF generado para un valor
  getPdfUrl(pdfKey: string): Observable<PresignedPdfResponse> {
    return this.api.get<PresignedPdfResponse>(`/pdfs/presigned?key=${encodeURIComponent(pdfKey)}`);
  }
}
